import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://trustsign-backend.onrender.com";

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Auth API calls
export const authAPI = {
  register: (userData) => api.post("/users/register", userData),
  login: (credentials) => api.post("/users/login", credentials),
  getProfile: () => api.get("/users/me"),
  updatePublicKey: (publicKey) => api.put("/users/me/publickey", { publicKey }),
};

// Document API calls
export const documentAPI = {
  signDocument: (documentData) => api.post("/documents/sign", documentData),
  getMyDocuments: () => api.get("/documents/my-documents"),
  getDocument: (documentId, includeData = false) =>
    api.get(`/documents/${documentId}?includeData=${includeData}`),
  getPublicDocument: (documentId, includeData = false) =>
    api.get(`/documents/public/${documentId}?includeData=${includeData}`),
  verifyDocument: (documentId, signature) =>
    api.post(`/documents/verify/${documentId}`, { signature }),
  verifyDocumentPublic: (documentId) =>
    api.post(`/documents/verify/${documentId}`, {}),
  deleteDocument: (documentId) => api.delete(`/documents/${documentId}`),
  getStats: () => api.get("/documents/stats"),
};

export default api;
